import React from 'react'

import DynamicHeroIcon from './DynamicHeroIcon'
import Link from 'next/link'
import Button from './Button'

interface NoItemsProps {
    children?: React.ReactNode
    title?: string
    description?: string
    iconName?: string
    route?: string
    routeText?: string
    onClick?: () => void
    buttonText?: string
    keepSmall?: boolean
}

const NoItems: React.FC<NoItemsProps> = (props) => {
    return (
        <div
            className={`${
                props.keepSmall ? '' : 'lg:min-h-[calc(100vh-(var(--dann-navbar-height-lg)*2))] '
            }flex flex-col justify-center`}
        >
            <div className="relative text-center space-y-6">
                {props.iconName && (
                    <DynamicHeroIcon
                        icon={props.iconName}
                        className="m-auto w-14 h-14 stroke-1 text-gray-300"
                        aria-hidden="true"
                    />
                )}
                <div className="max-w-prose m-auto">
                    {props.title && <h3 className="text-gray-500 mb-4">{props.title}</h3>}
                    {props.description && <p className="text-gray-400">{props.description}</p>}
                </div>

                {props.route && (
                    <div>
                        <Link href={props.route}>
                            <a>
                                <Button variant="primary">{props.routeText}</Button>
                            </a>
                        </Link>
                    </div>
                )}

                {props.onClick && (
                    <div>
                        <Button variant="primary" onClick={props.onClick}>
                            {props.buttonText}
                        </Button>
                    </div>
                )}
                {props.children}
            </div>
        </div>
    )
}
export default NoItems
